"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferArchivedModal = void 0;
var OfferArchivedModal_1 = require("./OfferArchivedModal");
Object.defineProperty(exports, "OfferArchivedModal", { enumerable: true, get: function () { return OfferArchivedModal_1.OfferArchivedModal; } });
